import GlobalStyle from '@nbrace-monorepo-ui/commons/src/components/globalStyle';
import React from 'react';

// const isRootPage = (location: { pathname: string }) => {
//   return location.pathname === "" || location.pathname === "/"
// }
//
// const isHomePage = (location: { pathname: string }) => {
//   return /^\/home/.test(location.pathname)
// }

type Props = {
  children?: React.ReactNode;
  pageContext: {
    matchPath: string;
  };
  location: {
    pathname: string;
    search: string;
    hash: string;
  };
};

const RootLayout: React.FC<Props> = (props) => {
  const getContent = () => {
    return props.children;
  };

  return React.cloneElement(<GlobalStyle userTheme="Light">{getContent()}</GlobalStyle>);
};

export default RootLayout;
